import React from "react"

import Image from "../components/image"
import Gallery from "../components/gallery"
import parseMarkdownStr from "../components/gallery/parse-markdown-str"

// see: https://github.com/rexxars/react-markdown#node-types
export const renderers = {
  image: Image,
  code: ({ language, value }) => {
    if (language === "gallery") {
      return <Gallery items={parseMarkdownStr(value)} />
    }
    const className = language && `language-${language}`
    const code = React.createElement(
      "code",
      className ? { className: className } : null,
      value
    )
    return React.createElement("pre", {}, code)
  },
}
